import { Drawer, styled } from "@mui/material";
import { DrawerHeader } from "@common/SimpleDrawer/DrawerHeader";
import { ProductForm } from "@features/products/components/forms/ProductForm/ProductForm";

interface CreateProductDrawerProps {
  open: boolean;
  onClose: () => void;
}

// A standalone drawer (stacked over the stock form) for creating a product
// inline while adding stock. Shares the drawer header + form pattern.
export const CreateProductDrawer = ({
  open,
  onClose,
}: CreateProductDrawerProps) => (
  <Drawer anchor="right" open={open} onClose={onClose}>
    <SideDrawerContainer>
      <DrawerHeader
        title="Create Product"
        subtitle="Define a new product"
        onClose={onClose}
      />
      <ProductForm handleClose={onClose} createFromStockView />
    </SideDrawerContainer>
  </Drawer>
);

const SideDrawerContainer = styled("div")(({ theme }) => ({
  width: "100vw",
  position: "relative",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up("lg")]: {
    width: "500px",
  },
}));
